import React from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import QuizIcon from '@mui/icons-material/Quiz';
import SaveIcon from '@mui/icons-material/Save';
import TuneIcon from '@mui/icons-material/Tune';
import { Avatar, Button, Card, CardContent, Container, Grid, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const cards = [
  {
    title: 'Postavke igre',
    text: 'Podesite natjecatelje, naslov, uvod i dinamičke krugove.',
    to: '/admin/postavke-igre',
    icon: SettingsIcon
  },
  {
    title: 'Pitanja',
    text: 'Kreirajte setove pitanja i uređujte pitanja unutar svakog seta.',
    to: '/admin/pitanja',
    icon: QuizIcon
  },
  {
    title: 'Kvizovi',
    text: 'Spremite, učitajte i brišite spremljene konfiguracije kviza.',
    to: '/admin/kvizovi',
    icon: SaveIcon
  },
  {
    title: 'Opće postavke',
    text: 'Učitajte logotip i zvukove za točan, netočan i završen krug.',
    to: '/admin/opce-postavke',
    icon: TuneIcon
  }
];

export function AdminDashboardPage() {
  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4">Dashboard</Typography>
        <Grid container spacing={2}>
          {cards.map((card) => {
            const Icon = card.icon;
            return (
              <Grid item xs={12} md={6} key={card.to}>
                <Card sx={{ height: '100%' }}>
                  <CardContent sx={{ height: '100%' }}>
                    <Stack spacing={2} sx={{ height: '100%' }}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar sx={{ bgcolor: 'primary.main', width: 52, height: 52 }}>
                          <Icon />
                        </Avatar>
                        <Typography variant="h6">{card.title}</Typography>
                      </Stack>
                      <Typography color="text.secondary" sx={{ flexGrow: 1 }}>{card.text}</Typography>
                      <Button component={RouterLink} to={card.to} variant="contained">
                        Otvori
                      </Button>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </Container>
  );
}
